// Mirrors RefineryConflictError (see dataRefineryConfig.ts) — thrown when the
// server rejects an import (409 duplicate-filename conflict, or a 400
// structural/package-validation failure), so callers can display the server's
// exact message rather than a generic one.
export class ImportRefineryError extends Error {
    constructor(message: string, public conflictingFileNames?: string[]) {
        super(message);
        this.name = 'ImportRefineryError';
    }
}
